export interface BulkDeleteBatchResult {
  requestedCount: number;
  deletedCount: number;
}

export interface BulkDeleteProgress {
  processedCount: number;
  deletedCount: number;
}

export class BulkDeleteProgressError extends Error {
  readonly progress: BulkDeleteProgress;

  constructor(progress: BulkDeleteProgress) {
    super("Bulk delete stopped before all batches completed");
    this.name = "BulkDeleteProgressError";
    this.progress = progress;
  }
}

export async function deleteInSequentialBatches(
  ids: string[],
  sendBatch: (ids: string[]) => Promise<BulkDeleteBatchResult>,
  batchSize = 500,
): Promise<BulkDeleteProgress> {
  let processedCount = 0;
  let deletedCount = 0;
  for (let offset = 0; offset < ids.length; offset += batchSize) {
    const batch = ids.slice(offset, offset + batchSize);
    try {
      const result = await sendBatch(batch);
      processedCount += result.requestedCount;
      deletedCount += result.deletedCount;
    } catch {
      throw new BulkDeleteProgressError({ processedCount, deletedCount });
    }
  }
  return { processedCount, deletedCount };
}
